<template>
  <div
    v-if="show"
    class="modal d-block"
    tabindex="-1"
    @click.self="$emit('close')"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Trackings - {{ user?.first_name }} {{ user?.last_name }}
          </h5>
          <button class="btn-close" @click="$emit('close')"></button>
        </div>
        <div class="modal-body">
          <div v-if="loading" class="text-center py-4">
            Loading...
          </div>
          <div v-else-if="trackings.length === 0" class="text-muted text-center py-4">
            No trackings found
          </div>
          <div v-else class="list-group">
            <div
              v-for="tracking in trackings"
              :key="tracking.id"
              class="list-group-item"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <div class="fw-bold">{{ tracking.name || tracking.bucket }}</div>
                  <small class="text-muted">
                    {{ formatDate(tracking.started_at) }}
                  </small>
                </div>
                <div class="text-end">
                  <span class="badge bg-primary">
                    {{ formatDuration(tracking.duration) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";

export default {
  name: "UserTrackingsModal",
  props: {
    show: Boolean,
    user: Object,
    bucketId: Number,
  },
  emits: ["close"],
  data() {
    return {
      trackings: [],
      loading: false,
    };
  },
  methods: {
    loadWithFilters(userId, bucketId, date) {
      if (this.loading) return;
      
      this.loading = true;
      this.trackings = [];

      let url = `/work/times/user?`;
      const params = [];

      if (userId) {
        params.push(`user_id=${userId}`);
      }
      if (bucketId) {
        params.push(`bucket_id=${bucketId}`);
      }
      if (date) {
        const dateStr = date.toISOString().split("T")[0];
        params.push(`start_date=${dateStr}`);
        params.push(`end_date=${dateStr}`);
      }

      url += params.join("&");

      http.fetch(url).then((data) => {
        this.trackings = data.data || [];
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const d = new Date(dateString);
      return d.toLocaleString();
    },
    formatDuration(seconds) {
      if (!seconds) return "0s";
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      }
      return `${secs}s`;
    },
  },
};
</script>